<template>
  <div class="pt-20 px-8 bg-vice-light-grey rounded-br-lg rounded-tr-lg">
    <p class="text-base font-normal leading-6 text-vice-dark-teal">
      Please wait while the clinician debriefs the patient and disconnects
      <span class="font-bold">the medical devices.</span>
      This can take a few minutes.
    </p>
    <img
      class="block mx-auto mt-10"
      width="132"
      height="71"
      src="/image/icons/smart-glass.svg"
      alt="SmartGlass"
    />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
